<template>
    <div class="profile-events" v-if="events">
        <div class="profile-title">
            <div class="profile-title-wrap">
                <h3>События</h3>
                <div class="profile-title__icon" @click="openNewEvent()" v-if="itsYou">
                    <font-awesome-icon icon="plus" />
                </div>  
            </div>
            <div class="profile-switcher">
            <span @click="changeEventsType('participant')" :class="{active: events_type === 'participant'}">Участие</span>
            <span @click="changeEventsType('created')" :class="{active: events_type === 'created'}">Созданные</span>
            <!-- <span @click="events_type = 'near'" :class="{active: events_type === 'near'}">Ближайшие</span> -->
            </div>
        </div>
        <VueSlickCarousel v-if="events.length > 0" :arrows="false" class="profile-slider" :swipeToSlide="true" :variableWidth="true" :infinite="false">
            <div class="profile-event" v-for="event of events" :key="event.id" @mousedown="firstClick"
            @mouseup="openEvent(event, $event)">
            <div class="profile-event__image" :style="{ backgroundImage: 'url(' + event.cover + ')' }">
                <div class="profile-event__label" v-if="!event.cover">Event</div>
                <!-- <div class="profile-info">
                <p class="profile-info__date">4 дня назад</p>
                <div class="profile-activity">
                    <div class="profile-activity__item">
                    <img src="" alt="">
                    <p>14</p>
                    </div>
                    <div class="profile-activity__item">
                    <img src="" alt="">
                    <p>14</p>
                    </div>
                </div>
                </div> -->
            </div>
            <div class="profile-tags">
                <p v-for="cat in event.sports" :key="cat.id">{{ cat.ru }} {{ event.sports.length > 1 ? '+'+event.sports.length : '' }}</p>
            </div>
            <p class="profile__text">
                {{ event.title }}
            </p>
            </div>
        </VueSlickCarousel>
        <div v-else class="nothing">Пока что, {{ user.firstname }} не создал ни одного события.</div>
    </div>
</template>
<script>
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
export default {
    name: 'ProfileEvents',
    props: {
        events: {
            type: Array,
            require: true
        },
        itsYou: {
            type: Boolean,
            require: true
        },
        user: {
            type: Object,
            require: true
        }
    },
    data: () => {
        return {
            events_type: 'created'
        }
    },
    components: {
      VueSlickCarousel: () => import("vue-slick-carousel")
    },
    methods: {
        firstClick(event) {
            this.first_click = {
                x: event.clientX,
                y: event.clientY
            }
        },
        
        openEvent(event, $event) {
            let pos = {
                x: $event.clientX,
                y: $event.clientY
            };
            if (this.first_click.x == pos.x && this.first_click.y == pos.y) {
                this.$store.dispatch('changeMode', false);
                this.$router.push({
                name: 'event',
                params: { hash: event.id + '&' + event.hash },
                });
            }
        },
        openNewEvent() {
            this.$store.dispatch('setNewType', 'events');
            this.$store.dispatch('changeState', {element: 'workplace'});
        },
        changeEventsType(type) {
            this.events_type = type
            this.$store.dispatch('fetchProfileEvents', {type, user: this.user.id})
        },
    }
}
</script>